

// calculate the price
function calculatePrice(doors, drawers, collection) {
  let total = 0;
  let doorPrice = 0;
  let drawerPrice = 0;

  switch (collection) {
    case 'bella':
		drawerPrice = 28.26;
		doorPrice = 41.62;
      break;
	   case 'cambridge':
		drawerPrice = 47.35;
		doorPrice = 85.77;
		 break;
	   case 'cartmel':
		drawerPrice = 24.87;
		doorPrice = 38.03;
		 break;
	   case 'firbeck':
		drawerPrice = 19.63;
		doorPrice = 41.74;
		 break;
	   case 'grantham':
		drawerPrice = 77.07;
		doorPrice = 105.56;
		 break;
	   case 'jayline':
		drawerPrice = 24.78;
		doorPrice = 48.06;
		 break;
	   case 'lucente':
		drawerPrice = 30.68;
		doorPrice = 57.61;
	   	break;
	   case 'newmarket':
		drawerPrice = 47.35;
		doorPrice = 85.77;
		 break;
	   case 'oxford':
		drawerPrice = 32.37;
		doorPrice = 70.94;
		 break;
		case 'valore':
		drawerPrice = 15.73;
		doorPrice = 32.75;
      break;
	   case 'vivo':
		drawerPrice = 18.61;
		doorPrice = 32.63;
      break;
	  case 'wilton':
		drawerPrice = 33.67;
		doorPrice = 46.99;
      break;
	  case 'windsor':
		drawerPrice = 59.2;
		doorPrice = 104.76;
      break;
    case 'zurfiz':
		drawerPrice = 30.3;
		doorPrice = 67.38;
	  break;
    default:
      break;
  }

  total += doors * doorPrice;
  total += drawers * drawerPrice;
  
  return total;
}

// the function called when the button is clicked
function calculateTotalPrice() {
  const doors = parseInt(document.getElementById('doors').value);
  const drawers = parseInt(document.getElementById('drawers').value);
  const collection = document.getElementById('collection').value;
  const resultContainer = document.getElementById('result');

  if (isNaN(isNaN(doors) || isNaN(drawers))) {
    resultContainer.textContent = 'Enter valid values';
    return;
  }

  const total = calculatePrice(doors, drawers, collection);
  console.log(total);
  resultContainer.textContent = `Total price: £${Math.round(total)}`;
}

